import React, { FC, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Sidebar.module.scss';
import { SidebarToggle } from 'esa-ui-library';

interface SidebarProps {
	children: JSX.Element;
	opened?: boolean;
	dataId?: string;
}

const Sidebar: FC<SidebarProps> = ({ children, opened, dataId }): JSX.Element => {
	const [isOpened, setIsOpened] = useState(opened);

	const onSidebarToggle = () => {
		setIsOpened((cur) => !cur);
	};

	return (
		<aside className={`${styles.Sidebar} ${isOpened ? styles.Opened : ''}`} data-testid={dataId}>
			<section className={styles.SidebarContent}>{isOpened && children}</section>
			<i className={styles.ToggleIcon} onClick={onSidebarToggle} data-testid='sidebar-toggle'>
				<SidebarToggle />
			</i>
		</aside>
	);
};

Sidebar.propTypes = {
	opened: PropTypes.bool,
	dataId: PropTypes.string,
};

export { Sidebar };
